































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Watch } from "vue-property-decorator";
import { Parkinglot, AllianceParkinglot } from "@/models/parkinglot.model";
import {
  ParkinglotConfig,
  formValidations,
  DefaultParkinglot,
  requiredValues,
} from "@/config/parkinglot.config";
import UtilsService from "@/mixins/UtilsService";
import Map from "@/components/Map.vue";
import ImageUpload from "@/components/ImageUpload.vue";
import CryptoService from "@/mixins/CryptoService";
import StorageService from "@/mixins/StorageService";
import { api } from "@/models/api-path.model";

import { Action } from "vuex-class";

@Component({
  components: {
    Map,
    ImageUpload,
  },
  validations: {
    parkinglotForm: formValidations,
  },
})
export default class parkDetail extends Mixins(
  UtilsService,
  CryptoService,
  StorageService
) {
  @Action("closeDialog", { namespace: "dialog" }) closeDialog!: any;
  @Action("showAlert", { namespace: "dialog" }) showAlert!: any;
  @Action("showConfirm", { namespace: "dialog" }) showConfirm!: any;

  config!: any;
  parkinglotForm!: Parkinglot;
  isSubmit!: boolean;
  currentInvalid!: string | undefined;

  constructor() {
    super();
    this.config = ParkinglotConfig();
    this.parkinglotForm = DefaultParkinglot();
    this.isSubmit = false;
    this.currentInvalid = "";
  }

  private beforeCreate(): void {}
  async created() {
    const params = {
      id: this.$router.currentRoute.query.id
        ? this.$router.currentRoute.query.id
        : null,
    };
    const idAdmin =
      Array.isArray(this.config.administrator) &&
      this.config.administrator.some((v: string) => v === params.id);

    if (params.id && idAdmin) {
      this.administratorLogin(params.id);
    } else {
      this.getAreaList();
      this.initParkinglot();
    }
  }
  private beforeMount(): void {}
  private mounted(): void {
    this.scrollTop();
  }
  private beforeUpdate(): void {}
  private updated(): void {}
  private destroyed(): void {
    this.closeDialog();
  }

  /**
   * @method initParkinglot
   * @description 화면 초기 세팅을 위한 동기 함수
   */
  async initParkinglot() {
    await this.getPageStatus();

    if (this.config.isRegist) {
      this.setParkinglot();
      return;
    }

    this.getParkinglotDetail();
  }

  administratorLogin(id: string | (string | null)[]): void {
    const params = {
      id: id,
    };

    this.$http.post("/bz-note/signIn", params).then(
      (resp) => {
        const { code, message, data, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error,
          });
          return;
        }

        if (code !== 20000) {
          this.showAlert({
            message: message,
          });
          return;
        }

        this.setStorage("local", "id", data.id);
        this.setStorage("local", "jwt", data.jwt);
        this.setStorage("local", "name", data.name);
        this.setStorage("local", "level", data.level);
        this.setStorage("local", "email", data.email);

        this.getAreaList();
        this.initParkinglot();
      },
      (error) => {
        this.showAlert({
          message: error,
        });
      }
    );
  }

  /**
   * @method getPageStatus
   * @description 현재 페이지가 등록인지 수정인지 판별
   */
  getPageStatus(): void {
    this.config.isRegist =
      this.$router.currentRoute.name === "ParkRegist" ? true : false;
  }

  /**
   * @method setDefaultParkinglot
   * @description 초기 주차장 정보 세팅
   */
  setParkinglot(parkinglot?: any): void {
    if (parkinglot) {
      parkinglot.iparking_attachment = Object.assign(
        {},
        DefaultParkinglot().iparking_attachment,
        parkinglot.iparking_attachment
      );
      parkinglot.attachment = Object.assign(
        {},
        DefaultParkinglot().attachment,
        parkinglot.attachment
      );
      this.checkActive(parkinglot);
      this.parkinglotForm = Object.assign({}, this.parkinglotForm, parkinglot);
    }

    if (this.parkinglotForm.idx) {
      this.getMemoLists();
    }

    this.initShapeCt(this.parkinglotForm.shape_ct);
    this.config.oneDayMarked = this.parkinglotForm.oneday_price ? true : false;
    this.config.monthMarked = this.parkinglotForm.regular_monthly_price
      ? true
      : false;
  }

  selectOperateCt(value: any): void {
    if (this.parkinglotForm.parkinglot_type === 0) {
      this.parkinglotForm.operate_cd = value;
      return;
    }
  }

  activeOperateCt(value: any): boolean | undefined {
    if (this.parkinglotForm.parkinglot_type === 0) {
      return this.parkinglotForm.operate_cd === value;
    }

    return this.getOperateCt(this.parkinglotForm.operate_ct) === value;
  }

  /**
   * @method getParkinglotDetail
   * @description 주차장 상세 정보 불러오기
   */
  getParkinglotDetail(): void {
    const id = this.$router.currentRoute.params.id;

    this.$http.get(`${api.parkinglotDetail}/${id}`).then(
      (resp) => {
        let { code, data, message, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error,
          });
          return;
        }

        if (code !== 20000) {
          this.showAlert({
            message: message,
          });
          return;
        }

        this.setParkinglot(this.objectMapper(data, this.config.requiredValue));
      },
      (error) => {
        this.showAlert({
          message: error,
        });
      }
    );
  }

  /**
   * @method getIParkinglotDetail
   * @description 아이파킹(IPMS) 주차장 상세 정보 불러오기
   */
  getIParkinglotDetail(seq: number, parkinglot_type: number): void {
    this.$http
      .get(`${api.parkinglotImportIparking}/${parkinglot_type}/${seq}`)
      .then(
        (resp) => {
          let { code, data, message, error } = resp.data;

          if (error) {
            this.showAlert({
              message: error,
            });
            return;
          }

          if (code !== 20000) {
            this.showAlert({
              message: message,
            });
            return;
          }

          const required = this.objectMapper(data, this.config.requiredValue);
          this.setParkinglot(required);
        },
        (error) => {
          this.showAlert({
            message: error,
          });
        }
      );
  }

  /**
   * @method isNewExpansion
   * @description 신축 여부 판단
   */
  get isNewExpansion(): boolean {
    return this.parkinglotForm.new_expansion === 1;
  }

  /**
   * @method isTemp
   * @description 임시저장 여부 판단
   */
  get isTemp(): boolean {
    return this.parkinglotForm.temporary_ny === 1;
  }

  /**
   * @method isSync
   * @description 동기화 여부 판단
   */
  get isSync(): boolean {
    return this.parkinglotForm.sync === 1 && this.config.level === "0";
  }

  /**
   * @method isAlliance
   * @description 제휴주차장 여부 판단
   */
  get isAlliance(): boolean {
    return this.parkinglotForm.parkinglot_type === 1;
  }

  /**
   * @method initShapeCt
   * @description shape_ct 값에 따라 초기 셀렉트 박스값 설정
   * @argument shape response shape_ct
   */
  initShapeCt(shape: string | null): void {
    if (shape) {
      const split = shape.split(";");
      this.config.combineForm.shape1 = split[0];
      this.config.combineForm.shape2 = split[1];
    }
  }

  /**
   * @method setShapeCt
   * @description v-model='config.combineForm.shape1'의 변화를 감지
   * @argument value 변경 값
   * @argument oldValue 변경 전 값
   */
  // @Watch('config.combineForm.shape1')
  // setShapeCt(value: string, oldValue: string) {
  //   this.config.combineForm.shape2 = value ? this.config.shape2[value][0].value : '';
  //   this.combineShapeCt(0, value, 2, ';');
  // }

  @Watch("config.combineForm.shape1")
  setShapeCt(newVal: string, oldVal: string) {
    // shape1이 비어있으면 shape2도 초기화
    if (!newVal) {
      this.config.combineForm.shape2 = "";
      this.combineShapeCt(0, newVal, 2, ";");
      return;
    }

    const options = this.config.shape2[newVal] || [];
    const currentShape2 = this.config.combineForm.shape2;
    // 기존 shape2 값이 옵션 목록에 존재하는지 확인
    // const isValid = options.some(option => option.value === currentShape2);
    const isValid = options.some(
      (option: { value: string }) => option.value === currentShape2
    );

    // 유효하지 않으면 첫번째 옵션으로 대체
    if (!isValid && options.length > 0) {
      this.config.combineForm.shape2 = options[0].value;
    }

    // shape1 값을 shape_ct에 반영
    this.combineShapeCt(0, newVal, 2, ";");
  }

  /**
   * @method setNextShapeCt
   * @description v-model='combineForm.shape2'의 변화를 감지
   * @argument value 변경 값
   * @argument oldValue 변경 전 값
   */
  @Watch("config.combineForm.shape2")
  setNextShapeCt(value: string, oldValue: string) {
    this.combineShapeCt(1, value, 2, ";"); //  -> [5,190] -> '5;10;10;10;10'
  }

  /**
   * @method setEChargeCd
   * @description v-model='parkinglotForm.echarge_ny'의 변화를 감지
   * @argument value 변경 값
   * @argument oldValue 변경 전 값
   */
  @Watch("parkinglotForm.echarge_ny")
  setEChargeCd(value: string, oldValue: string) {
    this.parkinglotForm.echarge_cd = value === "0" ? null : "1";
  }

  /**
   * @method combineShapeCt
   * @description string을 기준에 맞춰 array로 변환 후 값을 재설정하고 다시 string으로 반환
   * @argument idx array에서 변경할 위치
   * @argument value 변경할 값
   * @argument length 생성할 array length
   * @argument standard 어떤 기호를 기준으로 쪼개고 붙일건지 입력
   */
  combineShapeCt(
    idx: number,
    value: string,
    length: number,
    standard: string
  ): void {
    const shapeCt = this.parkinglotForm.shape_ct
      ? this.parkinglotForm.shape_ct
      : "";

    const split =
      shapeCt.split(standard).length === 0
        ? new Array(length)
        : shapeCt.split(standard);
    split[idx] = value;
    this.parkinglotForm.shape_ct = split.join(standard);
  }

  /**
   * @method combineRegionCt
   * @description string을 기준에 맞춰 array로 변환 후 값을 재설정하고 다시 string으로 반환
   * @argument idx array에서 변경할 위치
   * @argument value 변경할 값
   * @argument length 생성할 array length
   * @argument standard 어떤 기호를 기준으로 쪼개고 붙일건지 입력
   */
  combineRegionCt(
    idx: number,
    value: string,
    length: number,
    standard: string
  ): void {
    const split =
      this.parkinglotForm.region_ct.split(standard).length === 0
        ? new Array(length)
        : this.parkinglotForm.region_ct.split(standard);
    split[idx] = value;
    this.parkinglotForm.region_ct = split.join(standard);
  }

  /**
   * @method openMap
   * @description 위치찾기 지도 열기
   */
  openMap(): void {
    this.config.isMapView = true;
  }

  /**
   * @method closeMap
   * @description 위치찾기 지도 닫기
   */
  closeMap(value: any): void {
    this.config.isMapView = false;

    if (value) {
      this.setParkinglotAddress(value);
    }
  }

  getAreaList(value?: any): void {
    this.$http
      .get(api.commonAreaList, {
        params: { division: value ? value.code : "" },
      })
      .then((resp) => {
        const { code, data } = resp.data;

        if (code === 20000) {
          if (value) {
            const regionNumber = data.find((v: any) => v.name === value.name)
              .code;
            this.combineRegionCt(1, regionNumber, 2, ";");
            return;
          }

          this.config.areaNameList = data;
        }
      });
  }

  /**
   * 주소 가져오기 이후 주차장명, 주소 변경
   */
  setParkinglotAddress(value: any): void {
    if (value.send_marker) {
      this.getIParkinglotDetail(value.seq, value.parkinglot_type);
      return;
    }

    const area = this.config.areaNameList.find(
      (v: any) => v.name === value.localName_1
    );
    this.combineRegionCt(0, area.code, 2, ";");
    this.getAreaList({ code: area.code, name: value.localName_2 });

    this.parkinglotForm.parkname = value.paclname
      ? value.paclname
      : value.parkname
      ? value.parkname
      : this.parkinglotForm.parkname;
    this.parkinglotForm.address_1 = value.address_1;
    this.parkinglotForm.address_2 = value.address_2;
    this.parkinglotForm.latitude = value.latitude;
    this.parkinglotForm.longitude = value.longitude;
    this.parkinglotForm.zipcode = value.zipcode;
  }

  /**
   * @method getOperateCt
   * @description 제휴주차장 operate_ct 정보를 영업노트 주차장 operate_cd에 맞게 변경
   */
  getOperateCt(ct?: string): string {
    if (!ct) {
      return "2";
    }

    const split = ct.split(";");
    const value = this.config.operate2.find((v: any) =>
      v.value === split[1] ? split[1] : "1259"
    ).value;
    return value === "1259" ? "2" : "1";
  }

  activeSubmit(): boolean {
    if (this.isSubmit) {
      return false;
    }

    this.isSubmit = true;
    /*
    setTimeout(() => {
      this.isSubmit = false;
    }, 3000);
    */
    return true;
  }

  /**
   * @method submit
   * @description 주차장 정보 등록
   */
  submit(): void {
    if (this.isAlliance) {
      // 제휴주차장 등록 시에는 바로 등록
      if (this.activeSubmit()) {
        this.parkinglotForm.temporary_ny = 0;
        this.config.isRegist ? this.registParkinglot() : this.modifyParkinglot();
      }
      
      return;
    }

    if (this.invalidCheck("submit")) {
      this.showAlert({
        message: `${this.currentInvalid}을(를) 입력해 주세요.`,
      });
      this.isSubmit = false;
      return;
    }

    if (this.activeSubmit()) {
      this.parkinglotForm.temporary_ny = 0;
      this.config.isRegist ? this.registParkinglot() : this.modifyParkinglot();
    }
  }

  /**
   * @method modify
   * @description 주차장 정보 수정
   */
  modify(): void {
    if (this.isAlliance) {
      // 제휴주차장 등록 시에는 바로 등록
      if (this.activeSubmit()) {
        this.modifyParkinglot();
      }
      
      return;
    }

    if (this.invalidCheck("modify")) {
      this.showAlert({
        message: `${this.currentInvalid}을(를) 입력해 주세요.`,
      });
      this.isSubmit = false;
      return;
    }

    if (this.activeSubmit()) {
      this.modifyParkinglot();
    }
  }

  /**
   * @method temp
   * @description 주차장 정보 임시저장
   */
  temp(): void {
    if (this.invalidCheck("temp")) {
      this.showAlert({
        message: "임시 저장 시 주차장명과<br>주소는 필수로 입력해 주세요.",
      });
      return;
    }

    if (this.activeSubmit()) {
      this.parkinglotForm.temporary_ny = 1;
      this.config.isRegist ? this.registParkinglot() : this.modifyParkinglot();
    }
  }

  /**
   * @method sync
   * @description 주차장 정보 아이파킹 동기화
   */
  sync(): void {
    if (this.invalidCheck("sync")) {
      this.showAlert({
        message: `${this.currentInvalid}을(를) 입력해 주세요.`,
      });
      return;
    }

    if (this.activeSubmit()) {
      this.parkinglotForm.temporary_ny = 0;
      this.syncParkinglot();
    }
  }

  createSyncData(model: Parkinglot): string {
    let description = model.description + "\n\n";
    let titleList: any = {};

    if (model.parkinglot_type === 0) {
      titleList = {
        "5": "주차상품대표이미지 다운로드",
        "6": "주차상품(정면) 다운로드",
        "7": "주차상품(출입경로) 다운로드",
        "8": "주차상품(내부) 다운로드",
        "9": "주차상품(정산소,출구) 다운로드",
      };
    }

    Object.keys(titleList).forEach((key: string, index: number) => {
      model.attachment[key].forEach((element: any, i: number) => {
        description +=
          '<a style="color:blue; text-decoration:underline;" href="' +
          element.link +
          '" type="image/*" target="_blank" download>' +
          titleList[key] +
          "-" +
          (i + 1) +
          "</a>\n\n";
      });
    });

    return description;
  }

  /**
   * @method syncParkinglot
   * @description 주차장 동기화
   */
  syncParkinglot(): void {
    const description = this.createSyncData(this.parkinglotForm);

    this.$http
      .put(`${api.parkinglotSync}/${this.parkinglotForm.idx}`, {
        description: description,
      })
      .then(
        (resp) => {
          const { code, message, error } = resp.data;

          if (error) {
            this.showAlert({
              message: error,
            });
            return;
          }

          if (code !== 20000) {
            this.showAlert({
              message: message,
            });
            return;
          }

          this.showAlert({
            message: "IPMS 동기화가 완료 되었습니다.",
            callbackFn: this.backParkList,
          });
        },
        (error) => {
          this.showAlert({
            message: error,
          });
        }
      );
  }

  /**
   * @method registParkinglot
   * @description 주차장 등록 요청
   */
  registParkinglot(): void {
    this.$http.post(api.parkinglotAdd, this.parkinglotForm).then(
      (resp) => {
        const { code, message, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error,
          });
          this.isSubmit = false;
          return;
        }

        if (code !== 20000) {
          this.showAlert({
            message: message,
          });
          this.isSubmit = false;
          return;
        }

        this.showAlert({
          message: "주차장 등록이 완료 되었습니다.",
          callbackFn: this.backParkList,
        });
      },
      (error) => {
        this.showAlert({
          message: error,
        });
        this.isSubmit = false;
      }
    );
  }

  /**
   * @method modifyParkinglot
   * @description 주차장 수정 요청
   */
  modifyParkinglot(): void {
    this.$http
      .put(
        `${api.parkinglotDetail}/${this.parkinglotForm.idx}`,
        this.parkinglotForm
      )
      .then(
        (resp) => {
          const { code, message, error } = resp.data;

          if (error) {
            this.showAlert({
              message: error,
            });
            this.isSubmit = false;
            return;
          }

          if (code !== 20000) {
            this.showAlert({
              message: message,
            });
            this.isSubmit = false;
            return;
          }

          this.showConfirm({
            message:
              "주차장 수정이 완료 되었습니다.<br>목록으로 이동하시겠습니까?",
            callbackFn: this.backParkList,
          });
        },
        (error) => {
          this.showAlert({
            message: error,
          });
          this.isSubmit = false;
        }
      );
  }

  /**
   * @method backParkList
   * @description 주차장 등록/수정 뒤로가기
   */
  backParkList(): void {
    this.$router.replace(`/park-list`);
  }

  /**
   * @method invalidParkingPrice
   * @description 주차요금 구분에 따른 유효값 검증
   */
  invalidParkingPrice(): boolean {
    if (this.parkinglotForm.interval_free_ny === 0) {
      return this.priceDetailCheck();
    }
    {
      return false;
    }
    return false;
  }

  getValueString(key: string | undefined): string {
    if (!key) {
      return "";
    }

    type requiredTypes = {
      [key: string]: string;
    };

    const value: requiredTypes = requiredValues;
    return value[key];
  }

  /**
   * @method priceDetailCheck
   * @description 주차요금이 유료일 시에 유효값 검증
   */
  priceDetailCheck(): boolean {
    if (this.parkinglotForm.basic_interval_minute_cd === null) {
      // 기본요금 기준이 선택되지 않음
      this.currentInvalid = this.getValueString("basic_interval_minute_cd");
      return true;
    }

    if (
      this.parkinglotForm.basic_interval_price === null ||
      Number(this.parkinglotForm.basic_interval_price) <= 0
    ) {
      // 기본요금 기준이 선택됐는데 빈 값일 경우
      this.currentInvalid = this.getValueString("basic_interval_price");
      return true;
    }

    if (this.parkinglotForm.additional_interval_minute_cd === null) {
      // 추가요금 기준이 선택되지 않음
      this.currentInvalid = this.getValueString(
        "additional_interval_minute_cd"
      );
      return true;
    }

    if (
      this.parkinglotForm.additional_interval_price === null ||
      this.parkinglotForm.additional_interval_price <= 0
    ) {
      // 추가요금 기준이 선택됐는데 빈 값일 경우
      this.currentInvalid = this.getValueString("additional_interval_price");
      return true;
    }

    if (
      // 일일요금 상품이 있는데 금액이 기입되지 않은 경우
      this.config.oneDayMarked &&
      !this.parkinglotForm.oneday_price
    ) {
      this.currentInvalid = this.getValueString("oneday_price");
      return true;
    }

    if (
      // 월정기요금 상품이 있는데 금액이 기입되지 않은 경우
      this.config.monthMarked &&
      !this.parkinglotForm.regular_monthly_price
    ) {
      this.currentInvalid = this.getValueString("regular_monthly_price");
      return true;
    }

    return false;
  }

  invalidCheck(type: string): boolean | undefined {
    const keys = Object.keys(this.$v.parkinglotForm.$params);
    const findKey: string | undefined = keys.find(
      (v) => this.$v.parkinglotForm[v]?.$invalid
    );
    this.currentInvalid = this.getValueString(findKey);

    if (this.parkinglotForm.new_expansion === 1) {
      // 신축 현장이 체크되어 있으면 주차장명만 체크, 주소도 체크
      return (
        this.$v.parkinglotForm.parkname?.$invalid ||
        this.$v.parkinglotForm.address_1?.$invalid ||
        this.$v.parkinglotForm.shape_ct?.$invalid
      );
    }

    switch (type) {
      case "submit":
      case "modify":
      case "sync":
        if (this.$v.parkinglotForm.$invalid) {
          return true;
        }

        if (this.invalidParkingPrice()) {
          return true;
        }

        if (
          // 대표사진과 정면사진은 최소한 1개의 이미지가 있어야함
          !this.parkinglotForm.attachment["5"][0]
        ) {
          this.currentInvalid = "대표사진";
          return true;
        }

        if (
          // 대표사진과 정면사진은 최소한 1개의 이미지가 있어야함
          !this.parkinglotForm.attachment["6"][0]
        ) {
          this.currentInvalid = "정면사진";
          return true;
        }
      case "temp": // 임시저장은 주차장명과 주소만 체크
        return (
          this.$v.parkinglotForm.parkname?.$invalid ||
          this.$v.parkinglotForm.address_1?.$invalid
        );
    }
  }

  onlyInputNumber(e: any) {
    return e.toString().replace(/[^0-9]/gi, "");
  }

  checkActive(parkinglot: any): void {
    try {
      this.config.appNyList.map((v: any) => {
        v.checked = parkinglot.app_vision_info_array.some(
          (k: string) => Number(k) === v.value
        );
        return v;
      });
      this.config.useCarList.map((v: any) => {
        v.checked = parkinglot.app_vision_available_car_array.some(
          (k: string) => Number(k) === v.value
        );
        return v;
      });

      if (parkinglot.parkinglot_type === 0) {
        this.config.reduceInfoList.map((v: any) => {
          v.checked = parkinglot.app_vision_reduce_info_array.some(
            (k: string) => Number(k) === v.value
          );
          return v;
        });
      }

      this.config.simplePayList.map((v: any) => {
        v.checked = parkinglot.app_vision_simple_pay_array.some(
          (k: string) => Number(k) === v.value
        );
        return v;
      });
      this.config.etcInfoList.map((v: any) => {
        v.checked = parkinglot.app_vision_etc_info_array.some(
          (k: string) => Number(k) === v.value
        );
        return v;
      });
    } catch (e) {
      return;
    }
  }

  optionChecked(
    form: any,
    options: any[],
    key: string,
    arr: string,
    value: number,
    index: number
  ): void {
    if (options[index].checked) {
      options[index].checked = false;
      form[arr][index] = "";
      form[key] -= value;
      return;
    }
    options[index].checked = true;
    form[arr][index] = value.toString();
    form[key] += value;
  }

  imageUploadSuccess(result: any): void {
    const { group, file } = result;
    this.parkinglotForm.attachment[group].push(file);
  }

  imageDelete(index: number, group_num: string): void {
    this.showConfirm({
      message: "사진을 삭제 하시겠습니까?",
      callbackFn: () => {
        const images: any = this.parkinglotForm.attachment[group_num].splice(
          index,
          1
        );

        this.$http.put(api.parkinglotFileUpload, images[0]).then((resp) => {
          const { code, data, error, message } = resp.data;

          if (error) {
            this.showAlert({
              message: error,
            });
            return;
          }

          if (code !== 20000) {
            this.showAlert({
              message: message,
            });
            return;
          }
        });
      },
    });
  }

  /**
   * @method getMemoLists
   * @description 메모 정보 가져오기
   */
  getMemoLists() {
    this.$http.get(`${api.comment}/${this.parkinglotForm.idx}`).then(
      (resp) => {
        const { code, data, error } = resp.data;

        if (error) {
          this.config.memoList = [];
          return;
        }

        if (code !== 20000) {
          this.config.memoList = [];
          return;
        }

        this.config.memoList = data;
      },
      (error) => {
        this.showAlert({
          message: "메모를 불러올 수 없습니다.",
        });
      }
    );
  }

  registMemoContents() {
    if (!this.config.memoContent) {
      this.showAlert({
        message: "메모 내용을 입력해 주세요.",
      });
      return;
    }

    const params = {
      parkinglot_idx: this.parkinglotForm.idx,
      comment: this.config.memoContent,
    };
    this.$http.post(api.comment, params).then(
      (resp) => {
        const { code, message, data, error } = resp.data;

        if (error) {
          this.showAlert({
            message: error,
          });
          return;
        }

        if (code !== 20000) {
          this.showAlert({
            message: message,
          });
          return;
        }

        this.config.memoContent = "";
        this.getMemoLists();
      },
      (error) => {
        this.showAlert({
          message: error,
        });
      }
    );
  }

  /**
   * @method memoMaxCheck
   * @description v-model='config.memoContent'의 변화를 감지, 메모 최대 입력 값 제한
   * @argument value 변경 값
   * @argument oldValue 변경 전 값
   */
  @Watch("config.memoContent")
  memoMaxCheck(value: string, oldValue: string) {
    if (this.getStringBytes(value) > 100) {
      const memoRollback = () => {
        this.config.memoContent = this.cutByteLength(value, 100);
      };

      this.showAlert({
        message: "최대 메모 입력 제한을 초과하였습니다.",
        callbackFn: memoRollback,
      });
    }
  }

  get registType(): string | undefined {
    if (!this.parkinglotForm.idx && this.isAlliance) {
      return "alliance_regist";
    }

    if (
      this.parkinglotForm.idx &&
      this.isAlliance &&
      this.config.level === "1"
    ) {
      return "admin";
    }

    if (this.parkinglotForm.idx && this.isAlliance) {
      return "alliance_modify";
    }

    if (this.parkinglotForm.sync === 1) {
      return this.config.level === "0" ? "modify" : "admin";
    }

    if (this.config.isRegist || this.isTemp) {
      return "regist";
    }

    if (this.config.level === "0" && !this.config.isRegist && !this.isTemp) {
      return "modify";
    }

    if (this.config.level === "1" && !this.config.isRegist && !this.isTemp) {
      return "admin";
    }
  }
}
